module.exports = __webpack_public_path__ + "static/img/CC BY-NC-ND.cefeea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cc/CC BY-NC-ND.png
// module id = zOG0
// module chunks = 16